import { render, staticRenderFns } from "./action-cell.vue?vue&type=template&id=9639c494&scoped=true&"
import script from "./action-cell.vue?vue&type=script&lang=js&"
export * from "./action-cell.vue?vue&type=script&lang=js&"
import style0 from "./action-cell.vue?vue&type=style&index=0&id=9639c494&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9639c494",
  null
  
)

export default component.exports